module.exports = __webpack_public_path__ + "static/media/jogging_track.bf21dd83.jpg";